import {
  Chip,
  CircularProgress,
  Grid,
  TextField,
  useTheme
} from '@material-ui/core'
import Autocomplete, {
  createFilterOptions
} from '@material-ui/lab/Autocomplete'
import { useEffect, useState } from 'react'
import toastError from '../../errors/toastError.js'
import api from '../../services/api.js'
import { i18n } from '../../translate/i18n.js'
import { useStyles } from './style.js'

const filter = createFilterOptions()

export function ClientSelect({
  label,
  onSelected,
  allowCreate = false,
  onCreateCliente,
  excludeId,
  placeholder,
  value
}) {
  const classes = useStyles()
  const theme = useTheme()

  const [clientes, setClientes] = useState([])
  const [loading] = useState(false)
  const [searchParam, setSearchParam] = useState('')
  const [selected, setSelected] = useState(null)

  useEffect(() => {
    if (searchParam.length < 2) {
      setClientes([])
      return
    }
    const fetchClientes = async () => {
      try {
        const { data } = await api.get('clientes', { params: { searchParam } })
        let clienteList = data.clientes.map(c => ({
          id: c.id,
          nome: c.nome,
          cpfCnpj: c.cpfCnpj,
          tipo: c.tipo,
          segmento: c.segmento
        }))
        if (excludeId) {
          clienteList = clienteList.filter(cliente => cliente.id !== excludeId)
        }
        setClientes(clienteList)
      } catch (err) {
        toastError(err)
      }
    }
    fetchClientes()
  }, [searchParam, excludeId])

  useEffect(() => {
    if (value) {
      setSelected(value)
    }
  }, [value])

  const handleChange = (event, value) => {
    if (value && value.inputValue && allowCreate && onCreateCliente) {
      onCreateCliente(value.inputValue)
      setSelected(null)
    } else {
      setSelected(value)
      onSelected(value ? value.id : null, value)
    }
  }

  const filterOptions = (options, params) => {
    const filtered = filter(options, params)
    if (
      allowCreate &&
      params.inputValue !== '' &&
      !options.some(option => option.nome === params.inputValue)
    ) {
      filtered.push({
        inputValue: params.inputValue,
        nome: `${i18n.t('common.add')} "${params.inputValue}"`
      })
    }
    return filtered
  }

  return (
    <Grid container spacing={1} alignItems="flex-end">
      <Grid xs={12} item>
        <Autocomplete
          className={classes.inputAutocomplete}
          size="small"
          options={clientes}
          value={selected}
          loading={loading}
          onChange={handleChange}
          filterOptions={filterOptions}
          noOptionsText=""
          popupIcon={null}
          getOptionLabel={option => {
            if (option.inputValue) return option.nome
            return `${option.nome}${option.cpfCnpj ? ` - ${option.cpfCnpj}` : ''}`
          }}
          renderOption={option => {
            // Replicamos a lógica do texto para exibir corretamente
            const displayText = option.inputValue
              ? option.nome
              : `${option.nome}${option.cpfCnpj ? ` - ${option.cpfCnpj}` : ''}`

            return <span className={classes.optionText}>{displayText}</span>
          }}
          renderTags={(value, getTagProps) =>
            value
              ? [
                  <Chip
                    key={value.id || value.inputValue}
                    variant="outlined"
                    style={{
                      backgroundColor: '#bfbfbf',
                      textShadow: '1px 1px 1px #000',
                      color:
                        theme.palette.type === 'dark'
                          ? theme.palette.dark_50.main
                          : theme.palette.white_100.main
                    }}
                    label={value.nome}
                    {...getTagProps({ index: 0 })}
                    size="small"
                  />
                ]
              : []
          }
          renderInput={params => (
            <div className={classes.inputWrapper}>
              <span>{label || i18n.t('common.client')}</span>
              <TextField
                {...params}
                variant="outlined"
                placeholder={placeholder}
                onChange={e => setSearchParam(e.target.value)}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }}
              />
            </div>
          )}
        />
      </Grid>
    </Grid>
  )
}
